class messageConst {
    // RTCC
    CONFIRM_REGIST = "登録します。よろしいですか？";
    CONFIRM_DELETE = "削除します。よろしいですか？";
    CONFIRM_SAVE_FAVORITE = "検索条件をお気に入りに登録しますか？";
    SUCCESS_REGIST = "登録完了しました。";
    SUCCESS_DELETE = "削除完了しました。";

    INPUT_ERROR = "※不正な項目が入力されています。内容を確認してください。";
    DESTINATION_ERROR = "※対象エリア・国・都市を選択してください。";
    EXIST_ERROR = "※入力された$targetは既に使用されています。";
    KEYWORD_ERROR = "※ひらがな、カタカナ、アルファベット、数字、記号は2文字以上のキーワードを指定してください。";
    NOT_SAVED_SEARCH = "※検索条件が保存されていません。";
    REPRESENT_ERROR = "※代表者が選択されていません。";
    CONDITION_ERROR = "※お申し込みに関する条件に同意してください。";
    ADULT_ERROR = "※「大人」を選択するには、チェックイン日時点で21歳以上である必要があります。";
    RESERVE_ERROR = "※予約に失敗しました。";
    CANCEL_ERROR = "※予約のキャンセルに失敗しました。";

    SELECT_RECOMMEND = "選択したホテルのエリア・国・都市情報を反映しました。";

    NOT_YET_COMPLETED_MESSAGE = 'まだご予約は確定していません。';
    CONFIRM_MESSAGE = "下記の内容でよろしければ「この内容で予約する」ボタンを、\n訂正したい場合は「戻る」ボタンを押してください。";
    CONFIRM_MESSAGE_SP = "下記の内容でよろしければ\n「この内容で予約する」ボタンを、訂正したい場合は\n「戻る」ボタンを押してください。";
    CONFIRM_GOLF = "キャンセルされたプランのゴルフが予約されています。\nゴルフのキャンセルを行いますか？";

    // 会員制
    FACILITY_ERROR = "施設を選択してください。";
    PEOPLE_NUM_ERROR = "１室ご利用人数は１～５名の範囲で入力してください。";
    IMPORTED_PEOPLE_NUM_ERROR = "ご利用人数は合計１～８名の範囲で入力してください。";
    ADULT_NUM_ERROR = "大人の人数が不足しています。";
    SEARCH_ERROR = "検索に失敗しました。";
    SEARCH_RESV_ERROR = "現在お預かりしているご予約はありません。";
    SEARCH_RESV_NOT_FOUND_ERROR = "※入力された番号は見当たりません。ご不明な場合はご利用施設までご連絡ください。";
    SELECT_RIGHT_ERROR = "全宿泊日の権利消化を選択してください。";
    MAX_LENGTH_ERROR = "入力可能な最大文字数を超過しています。";
    HANKAKU_KANA_ERROR = "半角カナで入力してください。";
    ZENKAKU_KANA_ERROR = "全角カナで入力してください。";
    INPUT_ACCOMPANY_ERROR = "代表者以外で少なくとも1人の同行者を入力してください。";
    REGISTRATION_ERROR = "登録に失敗しました。";
    ROOM_CAPACITY_ERROR = "選択されたプランはご入力の人数でご予約できません。"
    CHANGE_LIMIT_ERROR = "本日・明日・明後日のご予約はお電話にてご連絡ください。"
    IMPORTED_CHANGE_LIMIT_ERROR = "本日のご予約はお電話にてご連絡ください。"
    ILLEGAL_RESERVE_ERROR = "予約サイトでの変更範囲を超えております。ご利用施設までお電話でご連絡ください。"
    PLAN_NOT_FOUND_ERROR = "一致するプランが０件です。"
    UNAVAILABLE_ERROR = "空きがありません。"
    HOTEL_PLAN_NOT_FOUND_ERROR = "一致するプランが０件です。\n以下のような原因が考えられます。\n・検索条件に合致するプランがない\n・ご利用希望日のカレンダーの色の権利が不足している"
    OPENING_DATE_ERROR = "開業日を跨ぐ連泊予約のため、予約サイトではご予約いただけません。ご利用施設までお電話でご連絡ください。"
    OVERNIGHT_ERROR = "操作中に日付が変わったため、お手数ですが最初からやり直してください。"
    REQUIRE_KAIINKEN_ERROR = "ご予約には所定の会員権が必要です。\nまたは現在表示されている会員権では表示できません。";
    CRAWL_SEARCH_INFO = "※会員権を選択してなくても検索は可能です"
    CRAWL_SENYUUBI_ERROR = "占有日を照会できる会員権ではございません。"
    NOT_EXIST_SENYUUBI_ERROR = "この会員権は占有日の所有はありません"
    FAMILY_SENYUUBI_ERROR = "占有日を照会できるのは会員様ご本人のみとなります"
    CLOSE_FACILITY_SENYUUBI_ERROR = "開業前のため占有日はありません"
    SPACEBANK_BUTTON_TITLE = "スペースバンクの預け入れは\nこちらから（マイページ）"
    REQUIRE_INPUT_ERROR = "※未入力の項目があります。";
    VALID_INPUT_ERROR = "※入力内容のご確認お願いします。";
    MACHI_KENRI_ERROR = "ご入力いただいたお部屋タイプはお申込みすることができませんでした。\n部屋タイプを変更して再度お申込みいただくか、予約センターまたはメンバー事務局（ベイコート倶楽部）まで\nご連絡くださいませ。";
    RESTAURANT_KAIINKEN_ERROR = "申し訳ございません。こちらは会員権所有者限定のメニューとなります。\n会員権をお持ちの方はひも付け登録をされるか、RTTGアプリ事務局（052-300-8666）までご連絡ください。"
    RESTAURANT_VACANCY_ERROR = "選択された時間でご希望のメニューはご予約できません。"
    ESTHETIC_VACANCY_ERROR = "メニューが変更されたため時間を選択し直してください。"
    ALLERGY_SAMPLE_MESSAGE = "（例１）本人がえびアレルギー（火を通せば可）\n（例２）妻が青魚アレルギー（出汁は可）\n（例３）息子がキウイアレルギー（他フルーツは可）";
    RESERVE_MAIL_INFO_MESSAGE = "※利用日の3週間前にお知らせメールが届きます。\n3週間以内の予約の場合はメールは届きません";
    BAYCOURT_ROOM_PRICE_MESSAGE = "※エクシブオーナー様は、ゲスト料金にてご利用になれます。";
    ROOM_PRICE_MESSAGE = "※料金は変更となる場合がございます。";
    ROOM_IMAGE_MESSAGE = "※客室写真および客室平面図はイメージです。実際のレイアウトとは異なる部分がございます。また縮尺はルームタイプごとに異なります。あらかじめご了承ください。";
    RESTAURANT_VACANCY_MESSAGE = "※CRAWLで予約がとれるのは「〇」の時間になります。\n「×」の時間でテーブルの残数がある場合は、調整が必要になるため予約担当者にご相談ください。";
    FACILITY_DETAIL_MESSAGE = "【新機能】\n「詳細」をクリックすると部屋タイプ毎の空き情報とレストランの空き情報が一緒に表示されます。";
    BREAKFAST_VACANCY_MESSAGE = "※空き情報は宿泊日の翌日をご覧ください";
    HOME_FL_INFO_MESSAGE = "※「使用しない」を選んだ場合は占有日（権利）を優先して自動選択します。";
    HOME_FL_INFO_RED_MESSAGE = "※メンバー以外（ゲスト利用）の方がレッドの日にホームフローティング（占有日を消化しない利用）で宿泊される場合はゲスト料金となります。ルームチャージはお部屋タイプ選択画面でご確認ください。";
    
    WITHIN_3_DATE_MESSAGE = "3日以内のご予約に関しましては、" + "\n" + "下記ご連絡先までお問い合わせください。";
    WITHIN_3_DATE_TEL_NUM = "0797-25-2200";
    REQUIRE_KAIINKEN_MESSAGE = "ご予約には所定の会員権が必要です。";
    ESTHETIC_MENU_MESSAGE = "※メインメニューは1つまで選択可能です。";
    ESTHETIC_OPTION_MESSAGE = "※オプションメニューは任意で複数選択可能です。";
    ESTHETIC_SMS_MESSAGE = "※ご予約完了後、ショートメッセージ（SMS）をお送りします。";
    RESTAURANT_PRICE_MESSAGE = "※別途サービス料や個室料金等を頂戴いたします。";
    CANCEL_MACHI_MESSAGE = "※別途サービス料や個室料金等を頂戴いたします。";
    ESTHETIC_QR_NOTICE = "※下のボタンを押して、お部屋に設置されている二次元コードを読み取ってください。";
    ESTHETIC_QR_DEFAULT = "読み取りに成功するとお部屋番号が表示されます。";
    ESTHETIC_QR_INVALID = "お部屋に設置されている二次元コードを読み取ることができませんでした。";
    ESTHETIC_QR_SUCCESS = "お部屋番号の読み取りに成功しました。";

    PRICE_COMMENT = "※ディナーチョイスプラン選択時には夕食代金は含まれません。上記料金に別途夕食代金を申し受けます。";
    TAX_COMMENT = "※ホテルにより宿泊税および入湯税を別途申し受けます。";
    TRAVEL_SUPPORT_COMMENT = "※「全国旅行支援」の適用条件等により、割引額が異なる場合や、割引対象外となる場合がございます。\n詳しくはお問い合わせください。";
    TRAVEL_SUPPORT_PRICE_COMMENT = "※上記全国旅行支援の割引金額の表示から100円未満は切り捨てとなります。\nそのため、表示されたお支払い額の100円単位が異なる場合もございます。予めご了承ください"
    TRAVEL_SUPPORT_HOLIDAY_COMMENT = "※平日と休日が絡む連泊の場合、全国旅行支援の適用範囲や、表示されている割引額と異なる場合がございます。"
    TRAVEL_SUPPORT_TARGET_COMMENT = "※1人1泊あたりの旅行代金が平日2,999円以下もしくは休日1,999円以下の場合は、全国旅行支援の対象外となります。"

    ILLEGAL_ACCESS_ERROR = "不正な遷移が検出されました。";

    // ゴルフ一人予約
    GOLF_SOLO_CANCEL_ANNOTATION = "予約を変更する場合は新規でご予約頂き、\n既存予約はキャンセルして頂くようお願い致します。";

    // 姓と名の間に空白を入力してください。
    REQUIRE_SPACE_NAME = "姓と名の間に空白を入力してください。";
}

export default new messageConst();